import React, { useEffect, useState } from "react";
import axios from "../../config/authaxios";
import Dropdown from "../../css/dropdown.module.scss";
import { Button, Card, Paper, Stack, Typography } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import Body from "../../ui/Body";
import { useStyles } from "../../theme/theme";
import { useNavigate } from "react-router-dom";
import DateTimePickerStartViewRenderers from "./DateTimePickerStart";
import DateTimePickerEndViewRenderers from "./DateTimePickerEnd";



function TopupxOrders() {

  // const CouponsColomns = [
  //   {
  //     field: 's_no',
  //     headerName: 'S. No.',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     filterable: false,
  //     renderCell: (index) => index.api?.getRowIndexRelativeToVisibleRows(index.row._id) + 1,
  //   },
  //   {
  //       field: 'p_name',
  //       headerName: 'voucher Name',
  //       headerClassName: 'super-app-theme--header',
  //       flex: 1,
  //       minWidth: 300,
  //   },
  //   {
  //     field: 'customer_id',
  //     headerName: 'Customer Id',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 200,
  //   },
  //   {
  //       field: 'v_order_id',
  //       headerName: 'Order Id',
  //       headerClassName: 'super-app-theme--header',
  //       flex: 1,
  //       minWidth: 200,
  //   },

  //   {
  //     field: 'email',
  //     headerName: 'Email',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 200,
  //   },
  //   {
  //     field: 'qty',
  //     headerName: 'Quantity',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 200,
  //   },
  //   {
  //     field: 'price',
  //     headerName: 'Price',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 200,
  //   },
  //   {
  //       field: 'amount',
  //       headerName: 'Total Amount ',
  //       headerClassName: 'super-app-theme--header',
  //       flex: 1,
  //       minWidth: 200,
  //   },

  //   {
  //     field: 'wallet',
  //     headerName: 'Coupon Id',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 200,
  //     renderCell: (params) => params.row.wallet ? params.row.wallet : "--"  ,
  //   },
  //   {
  //     field: 'status',
  //     headerName: 'Status',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 200,
  //     renderCell: (params) => params.row.status ? params.row.status : "--"  ,
  //   },
  //   // { 
  //   //   field: 'by_cash',
  //   //   headerName: 'By Cash',
  //   //   headerClassName: 'super-app-theme--header',
  //   //   flex: 1,
  //   //   minWidth: 200,
  //   //   renderCell: (params) => params?.row?.by_cash===true ? "true" : "false"  ,
  //   // },
  //   {
  //     field: 'expiry',
  //     headerName: 'Expiry',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 300,
  //     renderCell: (params) => {
  //       return (
  //         <Stack>
  //         {params.row.cards.map((item, index) => {
  //           return <p>{item.validity}</p>
  //         })}
  //         </Stack>  
  //       );
  //     }
  //   },
  //   {
  //     // field: 'expiry',
  //     headerName: 'Cards',
  //     headerClassName: 'super-app-theme--header',
  //     flex: 1,
  //     minWidth: 300,
  //     renderCell: (params) => {
  //       return (
  //         <div style={{display:"flex",flexDirection:"column",}}>
  //        { params.row.cards.map((item, index) => {
  //           return (
  //             <>

  //               <Typography>card Number: {item.cardNumber}</Typography>
  //               <Typography>card Pin: {item.cardPin}</Typography>


  //             </>

  //           );

  //         })}

  //     </div>

  //       );
  //     },

  //   },
  //   {
  //       field: 'by_cash',
  //       headerName: 'via cash',
  //       headerClassName: 'super-app-theme--header',
  //       flex: 1,
  //       minWidth: 200
  //   },
  //   {
  //       field: 'created_at',
  //       headerName: 'Created At',
  //       headerClassName: 'super-app-theme--header',
  //       flex: 1,
  //       minWidth: 200,
  //   }

  // ]

  const navigate = useNavigate()

  const [coupons, setCoupons] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [isType, setisType] = useState(1);
  const [status, setStatus] = useState(1);
  const [isMore, setIsMore] = useState(false);
  // const [load, setLoad] = useState(false);
  const [nodata, setNodata] = useState(false);
  const classes = useStyles();
  const [pageSize, setPageSize] = useState(25);
  const [startTime, setStartTime] = useState()
  const [endTime, setEndTime] = useState()
  const [publishers, setPublishers] = useState([]);
  const [selectedPublisher, setSelectedPublisher] = useState(null);
  useEffect(() => {
    fetchCoupon();
    fetchPublisher()
  }, [isType, limit, status,selectedPublisher]);

  const fetchCoupon = () => {
    setPage(0);
    //console.log("page-->",page)
    setNodata(true);
    setIsMore(false);
    let temp = {};

    if (page === 0 || page) {
      temp.page = page;
    }
    
    if(selectedPublisher){
      temp.publisher_id=selectedPublisher._id
    }

    if (limit) {
      temp.limit = limit;
    }

    if (isType) {
      temp.type = isType;
    }

    if (status) {
      temp.status = status;
    }

    temp.s_date = startTime;
    temp.e_date = endTime;


    // console.log("-->temp-->",temp)
    axios.post(`/admin/topupx/order-histories`, temp).then((res) => {
      console.log(res.data.response);
      let data = res.data.response;
      if (res.data.status) {
        setCoupons(res.data.response);
        if (data && data.length < limit) {
          setIsMore(true);
        }
        if (data.length === 0) {
          setNodata(true);
        } else {
          setNodata(false);
        }
        setPage(1);
      }
    });
  };
  const fetchPublisher = () => {
    axios.get(`/admin/publishers/list`).then((res) => {
      setPublishers([{ name: "All" }, ...res?.data?.response])
    });
  };


  const fetchCouponbySearch = () => {
    setPage(0);
    //console.log("page-->",page)
    setNodata(true);
    setIsMore(false);
    let temp = {};

    if (page === 0 || page) {
      temp.page = 0;
    }
    
    if(selectedPublisher){
      temp.publisher_id=selectedPublisher._id
    }

    if (limit) {
      temp.limit = limit;
    }

    if (isType) {
      temp.type = isType;
    }

    if (status) {
      temp.status = status;
    }

    temp.s_date = startTime;
    temp.e_date = endTime;


    //console.log("-->temp-->",temp)
    axios.post(`/admin/topupx/order-histories`, temp).then((res) => {
      //console.log(res.data.response);
      let data = res.data.response;
      if (res.data.status) {
        setCoupons(res.data.response);
        if (data && data.length < limit) {
          setIsMore(true);
        }
        if (data.length === 0) {
          setNodata(true);
        } else {
          setNodata(false);
        }
        setPage(1);
      }
    });
  };



  const Showmore = () => {
    setNodata(true);
    setIsMore(false);
    let temp = {}

    if (page === 0 || page) {
      temp.page = page;
    }

    if (limit) {
      temp.limit = limit;
    }

    if(selectedPublisher){
      temp.publisher_id=selectedPublisher._id
    }

    if (isType) {
      temp.type = isType
    }
    if (status) {
      temp.status = status
    }

    console.log("startTime", startTime);
    console.log("endTime", endTime);
    temp.s_date = startTime;
    temp.e_date = endTime;

    //console.log("-->temp-->",temp)
    axios.post(`/admin/topupx/order-histories`, temp).then((res) => {
      let data = res.data.response;
      //console.log("-->",data)
      let temp = [...coupons, ...data];
      if (data.length < limit) {
        setIsMore(true);
      }
      setCoupons(temp);
      setNodata(false);
      setPage(page + 1);
      // //console.log(res.data);
    });
  };



  const searchHandler = () => {
    setPage(0)
    fetchCouponbySearch();
  }

  return (
    <>
      {/* <section className={CardStyle.main}> */}

      <Body >

        <Typography style={{ color: "#646777", fontSize: "1.7rem", width: "50%" }}>Coupon</Typography>
        <Stack spacing={2} direction='row'>
          <div className={Dropdown.dropdown}>
            {coupons.length > 0 && !isMore &&
              <Button variant="contained" color='info' sx={{ my: 2 }} className={Dropdown.dropbtn} onClick={Showmore}>More</Button>}
          </div>


          <div className={Dropdown.dropdown}>
            <Button variant="contained" color='info' sx={{ my: 2 }} className={Dropdown.dropbtn}>limit:{limit}</Button>
            <div className={Dropdown.dropdown_content}>
              <a className={limit === 25 ? "disabled" : "notDisabled"} onClick={() => { setLimit(25); setPage(0) }}>25</a>
              <a disabled={limit === 50 ? true : false} onClick={() => { setLimit(50); setPage(0) }}>50</a>
              <a disabled={limit === 100 ? true : false} onClick={() => { setLimit(100); setPage(0) }}>100</a>
              <a disabled={limit === 500 ? true : false} onClick={() => { setLimit(500); setPage(0) }}>500</a>
              <a disabled={limit === 1000 ? true : false} onClick={() => { setLimit(1000); setPage(0) }}>1000</a>
            </div>
          </div>



          <div className={Dropdown.dropdown}>
            <Button variant="contained" color='info' sx={{ my: 2 }} className={Dropdown.dropbtn}>Type:{isType == '1' ? 'Quick Cilver' : isType == '2' ? 'Khiladi Adda' : isType == '3' ? 'Google Play' : isType == '4' ? 'UPI' : 'ALL'}</Button>
            <div className={Dropdown.dropdown_content} style={{ zIndex: "10" }}>
              <a onClick={() => { setisType("1"); setPage(0) }}>Quik Cilver</a>
              <a onClick={() => { setisType("2"); setPage(0) }}>Khiladi Adda</a>
              <a onClick={() => { setisType("3"); setPage(0) }}>Google Play</a>
              <a onClick={() => { setisType("4"); setPage(0) }}>UPI Trs</a>
            </div>
          </div>

          <div className={Dropdown.dropdown}>
            <Button variant="contained" color='info' sx={{ my: 2 }} className={Dropdown.dropbtn}>Status:{status == '1' ? 'Completed' : status == '2' ? 'Processing' : status == '3' ? 'Failed' : ' '}</Button>
            <div className={Dropdown.dropdown_content} style={{ zIndex: "10" }}>
              <a onClick={() => { setStatus("1"); setPage(0) }}>Completed</a>
              <a onClick={() => { setStatus("2"); setPage(0) }}>Processing</a>
              <a onClick={() => { setStatus("3"); setPage(0) }}>Failed</a>
            </div>
          </div>

          <div className={Dropdown.dropdown}>
            <Button variant="contained" color="info" sx={{ my: 2 }}>
              Publisher: {selectedPublisher?.name || "Select Publisher"}
            </Button>
            <div className={Dropdown.dropdown_content} style={{ cursor: "pointer" }}>
              {publishers?.map((pub) => (
                <a
                  key={pub._id}
                  onClick={() => {
                    setSelectedPublisher(pub);
                    setPage(0);
                  }}
                >
                  {pub.name}
                </a>
              ))}
            </div>
          </div>
        </Stack>
        <Stack spacing={2} direction='row' sx={{ mb: 2 }}>
          <DateTimePickerStartViewRenderers setStartTime={setStartTime} />
          <DateTimePickerEndViewRenderers setEndTime={setEndTime} />
          {startTime && endTime && <Button variant="contained" onClick={searchHandler}>Search</Button>}
        </Stack>
        {coupons.length > 0 ? <div style={{ width: "75vw", height: "35vw", overflow: "auto" }}>
          <table style={{ borderCollapse: "collapse" }}>
            <thead style={{ background: "#DC8449", color: "#fff", position: "sticky", top: "0px" }}>
              <tr>
                <th>S. No.</th>
                <th>Publisher Name</th>
                <th>Voucher Name</th>
                <th>Order Id</th>
                <th>QW Order Id</th>
                <th>Email</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Amount</th>
                <th>Wallet</th>
                <th>Status</th>
                <th>Cards</th>
                {/* <th>Free Cash Amount</th> */}
                <th>Free Cash txn id</th>
                <th>SKU</th>
                {/* <th>Used at</th> */}
                <th>Created at</th>

              </tr>
            </thead>
            <tbody>
              {coupons?.map((item, index) => {
                return (

                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.publisher_id?.name}</td>
                    <td>{item?.p_name}</td>
                    <td>{item?.v_order_id}</td>
                    <td>{item?.qw_order_id}</td>
                    <td>{item?.email}</td>
                    <td>{item?.qty}</td>
                    {/* <td style={{textDecorationLine:"underline",cursor:"pointer"}} onClick={()=>navigate(`/history-detail?orderId=${item?.order_id}`)}>{item?.order_id}</td> */}
                    <td>{item?.price}</td>
                    <td>{item?.amount}</td>
                    <td>{item?.wallet}</td>
                    <td>{item?.status}</td>
                    <td>
                      {item?.cards.map((it, index) => (
                        <>
                          <table key={index + "cards"} style={{ border: "2px solid green" }}>

                            <tr>
                              <td>Card Number</td>
                              <td>{it.cardNumber ? it.cardNumber : "---"}</td>

                            </tr>
                            <tr>

                              <td>Card Pin</td>
                              <td>{it.cardPin ? it.cardPin : "---"}</td>

                            </tr>
                            <tr>

                              <td>Validity</td>
                              <td>{it.validity ? it.validity : "---"}</td>

                            </tr>


                          </table>
                          <br />
                        </>

                      ))}
                    </td>
                    <td>{item?.free_cash_txn_id}</td>
                    <td>{item?.sku}</td>
                    <td>{item?.created_at}</td>
                    {/* <td>{item?.paid_at}</td> */}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div> : <div style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "center", padding: "200px 0" }}>No Data Available</div>

        }

        {/* {nodata && <section>Loading...</section>} */}
        {/*<Paper sx={{
          bgcolor: '#fff',
          '& .super-app-theme--header': {
            bgcolor: '#DC8449',
            color: '#fff',
          },
        }} elevation={0}>


          <DataGrid
            className={classes.root}
            sx={{
              border: 0,
            }}
            hideFooterPagination
            // // getRowHeight={() => 'auto'}
            autoHeight
            rows={coupons}
            columns={CouponsColomns}
            getRowId={(row) => row._id}
            disableSelectionOnClick
            disableRowSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
            // pagination
            pageSize={pageSize}

            disableColumnSelector
          />
        </Paper> */}
        {coupons.length > 0 && !isMore && <Button variant="contained" color='info' sx={{ my: 2 }} onClick={Showmore}>More</Button>}
      </Body>




      {/* </section> */}
    </>
  );
}

export default TopupxOrders;